import "../../global.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import AccessControl from "./AcessControl";
import ClientAccessControl from "../ClientAccessControl";

export const queryClient = new QueryClient();

const AcessControl = ({
  children,
  allowedPermissions,
  renderNoAccess,
}: any) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ClientAccessControl
        children={
          <AccessControl
            children={children}
            allowedPermissions={allowedPermissions}
            renderNoAccess={renderNoAccess}
          />
        }
        allowedPermissions={allowedPermissions}
        renderNoAccess={renderNoAccess}
      />
    </QueryClientProvider>
  );
};

export default AcessControl;
